import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    fontSize: 14,
    fontWeight: 500,
    textTransform: "unset",
    borderRadius: "8px !important",
    ...(props.color && {
      color: props.color,
    }),
    ...(props.backgroundColor && {
      backgroundColor: `${props.backgroundColor} !important`,
      "&:hover": {
        backgroundColor: `${props.backgroundColor} !important`,
      },
    }),
  }),
}));

function CustomButton(props, ref) {
  const buttonStyles = useStyles(props);
  return (
    <Button classes={buttonStyles} disableElevation ref={ref} {...props} />
  );
}

export default React.forwardRef(CustomButton);
